import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RecruitmentProject } from '../Dto/RecruitmentProject';
import { environment } from '../../environments/environment';

@Injectable()
export class RecruitmentProjectsService {
  
  constructor(private http: HttpClient) {
  }
  private getRecruitmentUrl = environment.settings.apiEndpoint + '/api/RecruitmentProjects/getrecruitment';;

 
  getRecruitmentProject(id: number) {
    return this.http.get<RecruitmentProject>(this.getRecruitmentUrl+'/'+id);
  }
 
}
